import { render, staticRenderFns } from "./picture_data.vue?vue&type=template&id=52f0c16a&"
import script from "./picture_data.vue?vue&type=script&lang=js&"
export * from "./picture_data.vue?vue&type=script&lang=js&"
import style0 from "./picture_data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports